/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiStandardCodeLookupRaw.ts      *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-standard-code-lookup-raw";

export class AutogenModelEdiStandardCodeLookupRaw<RowType extends ModelRow> extends Endpoint<RowType, RowEdiStandardCodeLookupRawFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiStandardCodeLookupRaw extends ModelRow<RowEdiStandardCodeLookupRawFields> {
	constructor(values?: Partial<RowEdiStandardCodeLookupRawFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiStandardCodeLookupRawFields {
	company_id: string;
	description: string;
	element_id: string;
	standard_code: string;
	version: string;
}

